var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobs = function SvgJobs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M14.375 11.875h1.252c1.15 0 2.083-.933 2.083-2.083V5.208c0-1.15-.933-2.083-2.083-2.083H7.918c-1.15 0-2.083.933-2.083 2.083v1.25m6.458 0H4.377c-1.15 0-2.084.933-2.084 2.084v4.583c0 1.15.934 2.083 2.084 2.083h.625v2.084l3.75-2.084h3.541c1.15 0 2.084-.933 2.084-2.083V8.542a2.085 2.085 0 0 0-2.084-2.084"
  })));
};
export default SvgJobs;